<div
  data-cy="confirm-dialog"
  class="cm-confirm-dialog"
  [ngStyle]="{ 'width.px': data.width ? data.width : defaultWidth }"
>
  <div class="cm-confirm-dialog__container">
    <header *ngIf="data.title" class="cm-confirm-dialog__header {{ data.titleAlign }}">
      <span class="typography__dialog-title"> {{ data.title | translate }} </span>
    </header>
    <section *ngIf="data.imgUrl || data.message" class="cm-confirm-dialog__content">
      <div *ngIf="data.imgUrl" class="cm-confirm-dialog__image mb-3">
        <img [src]="data.imgUrl" [alt]="data.altImg" />
      </div>
      <div
        *ngIf="data.message"
        data-cy="confirm-dialog-message"
        class="typography__body-1 {{ data.messageAlign }}"
        [innerHtml]="data.message | translate"
      ></div>
    </section>
  </div>
  <footer
    *ngIf="data.primaryAction || data.secondaryAction || data.tertiaryAction"
    class="cm-confirm-dialog__footer d-flex {{
      data.buttonsAlign ? data.buttonsAlign : 'justify-content-between'
    }}"
  >
    <div class="l-slot">
      <cm-basic-button
        *ngIf="data.tertiaryAction"
        [dataCy]="'secondary-button'"
        class="mr-2"
        [size]="BasicButtonSizes.MEDIUM"
        [color]="
          data.tertiaryAction?.color
            ? data.tertiaryAction.color
            : BasicButtonColors.PRIMARY
        "
        [mode]="data.tertiaryAction.mode"
        (clickEvent)="clickAction(data.tertiaryAction.label)"
        >{{ data.tertiaryAction.label | translate }}
      </cm-basic-button>
    </div>
    <div class="r-slot" *ngIf="data.primaryAction || data.secondaryAction">
      <cm-basic-button
        *ngIf="data.secondaryAction"
        [dataCy]="'secondary-button'"
        class="mr-2"
        [size]="BasicButtonSizes.MEDIUM"
        [color]="
          data.secondaryAction?.color
            ? data.secondaryAction.color
            : BasicButtonColors.PRIMARY
        "
        [mode]="data.secondaryAction.mode"
        (clickEvent)="clickAction(data.secondaryAction.label)"
        >{{ data.secondaryAction.label | translate }}
      </cm-basic-button>
      <cm-basic-button
        *ngIf="data.primaryAction"
        [dataCy]="'save-button'"
        [size]="BasicButtonSizes.MEDIUM"
        [color]="
          data.primaryAction?.color
            ? data.primaryAction.color
            : BasicButtonColors.PRIMARY
        "
        [mode]="data.primaryAction.mode"
        (clickEvent)="clickAction(data.primaryAction.label)"
        >{{ data.primaryAction.label | translate }}
      </cm-basic-button>
    </div>
  </footer>
  <cm-icon-button
    class="cm-confirm-dialog__close"
    data-cy="confirm-dialog-close"
    icon="close"
    [color]="BasicButtonColors.SECONDARY"
    (clickEvent)="closeDialog()"
  ></cm-icon-button>
</div>
